'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var panaceeOverviewGridItemComponent = exports.panaceeOverviewGridItemComponent = {
    template: require('./panacee-overview-grid-item.html'),
    bindings: {
        product: '=',
        isLast: '=',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        getProductDiscounts: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "common", "exceptionService", "gettextCatalog", "Analytics", "$stateParams", "$state", "productService", "authService", function controller($scope, cartService, common, exceptionService, gettextCatalog, Analytics, $stateParams, $state, productService, authService) {
        'ngInject';

        var vm = this;
        vm.categoryId = $stateParams.id;
        vm.productDiscountsOpen = false;
        vm.productDiscounts = {};
        vm.productDiscountClicked = productDiscountClicked;
        vm.loadProductDiscounts = loadProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.getDiscountPrice = getDiscountPrice;
        vm.getGrossProfit = getGrossProfit;
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.productClicked = productClicked;
        vm.isFebelcoCustomer = isFebelcoCustomer;

        /* Get the discount price */
        function getDiscountPrice() {
            return vm.product.price - vm.product.price * vm.product.discountPct / 100;
        }

        /* Get the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        /* google analytics when product clicked */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { sellerId: vm.product.sellerId, sellerName: vm.product.sellerName, discountId: vm.product.discountId });
            Analytics.productClick(vm.context);
            Analytics.trackEvent('Product', 'click', vm.product.name);
            common.log.info('Analysis: product clicked', vm.product.name);
        }

        /* google analytics when product clicked */
        function productDiscountClicked() {
            // Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { dimension1: vm.product.sellerId, dimension2: vm.product.sellerName, dimension3: vm.product.discountId });
            // Analytics.productClick(vm.context);
            Analytics.trackEvent('ProductDiscount', 'click', vm.product.name);
            common.log.info('Analysis: product discount clicked', vm.product.name);
        }

        /* load the product discounts */
        function loadProductDiscounts() {
            productDiscountClicked();
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;
                    vm.getProductDiscounts(vm.product).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        /* open the porduct discounts */
        function toggleProductDiscounts() {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    loadProductDiscounts();
                }
            }
        }

        /* close the product discounts */
        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/panacee-overview-grid-item.js
// module id = 964
// module chunks = 0